<template>
    <div>
        <v-card class="ma-2">
            <v-toolbar flat dense>
                <v-select
                    v-model="status"
                    :items="opcoesStatus"
                    label="Status"
                    outlined
                    dense
                    hide-details
                    clearable
                    class="filtro"
                    @change="carregar(1)"
                />

                <v-spacer/>

                <v-btn icon :loading="loading" @click="carregar(pagina)">
                    <v-icon>mdi-refresh</v-icon>
                </v-btn>
            </v-toolbar>

            <v-data-table
                :headers="headers"
                :items="itens"
                :loading="loading"
                :mobileBreakpoint="0"
                :items-per-page="rows"
                :server-items-length="total"
                :page="pagina"
                :footer-props="{ itemsPerPageOptions: [25, 50, 100] }"
                dense
                @update:page="carregar($event)"
                @update:items-per-page="onRows"
            >
                <template v-slot:item.created_at="{ item }">
                    {{ formatDate(item.created_at) }}
                </template>

                <template v-slot:item.empresa="{ item }">
                    {{ (item.empresa && item.empresa.fantasia) || item.empresa_id || '—' }}
                </template>

                <template v-slot:item.rota="{ item }">
                    {{ item.origem_host }}:{{ item.origem_porta }}
                    <v-icon x-small>mdi-arrow-right</v-icon>
                    {{ item.destino_host }}:{{ item.destino_porta }}
                </template>

                <template v-slot:item.status="{ item }">
                    <v-chip x-small label dark :color="statusMove(item.status).cor">
                        {{ statusMove(item.status).texto }}
                    </v-chip>

                    <span v-if="item.etapa && item.status !== 'concluido'" class="caption grey--text ml-1">
                        {{ etapa(item.etapa) }}
                    </span>

                    <div v-if="item.erro" class="caption red--text">{{ item.erro }}</div>
                </template>

                <template v-slot:item.conexao="{ item }">
                    <span v-if="item.estava_online === null" class="grey--text">—</span>
                    <span v-else>
                        {{ item.estava_online ? 'online' : 'offline' }}
                        <v-icon x-small>mdi-arrow-right</v-icon>
                        <span :class="{ 'amber--text text--darken-3': item.estava_online && !item.ficou_online }">
                            {{ item.ficou_online === null ? 'não conferido' : (item.ficou_online ? 'online' : 'offline') }}
                        </span>
                    </span>
                </template>

                <template v-slot:item.duracao_ms="{ item }">
                    {{ item.duracao_ms ? (item.duracao_ms / 1000).toFixed(1) + 's' : '—' }}
                </template>

                <template v-slot:item.user="{ item }">
                    {{ (item.user && item.user.name) || 'sistema' }}
                </template>
            </v-data-table>
        </v-card>
    </div>
</template>

<script>
import { statusMove, STATUS_MOVE, etapa } from './situacoes';

export default {
    name: 'TabHistorico',

    data: () => ({
        loading: false,
        itens: [],
        total: 0,
        pagina: 1,
        rows: 25,
        status: null,
        opcoesStatus: Object.keys(STATUS_MOVE).map(k => ({ value: k, text: STATUS_MOVE[k].texto })),
        headers: [
            { text: 'Quando', value: 'created_at' },
            { text: 'Empresa', value: 'empresa', sortable: false },
            { text: 'De → para', value: 'rota', sortable: false },
            { text: 'Status', value: 'status', sortable: false },
            { text: 'Conexão', value: 'conexao', sortable: false },
            { text: 'Duração', value: 'duracao_ms' },
            { text: 'Quem', value: 'user', sortable: false },
        ],
    }),

    mounted() {
        this.carregar(1);
    },

    methods: {
        statusMove,
        etapa,

        onRows(rows) {
            this.rows = rows;
            this.carregar(1);
        },

        async carregar(pagina = 1) {
            this.loading = true;
            this.pagina = pagina;

            try {
                const { data } = await this.$http.get('instancias-whatsapp/movimentacoes', {
                    params: { page: pagina, rows: this.rows, status: this.status || undefined },
                });

                this.itens = data.data || [];
                this.total = (data.meta && data.meta.total) || 0;
            } catch (e) {
                this.notify('Não foi possível carregar o histórico', 'error');
            }

            this.loading = false;
        },
    },
};
</script>

<style scoped>
.filtro {
    max-width: 240px;
}
</style>
